<template>
  <a @click="triggerAction">
    <MIcon name="history" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $tc('location') }} {{ $tc('history') }}
    </span>
    <FlotoDrawer :open="showDrawer" width="65%" @hide="hideDrawer">
      <template v-slot:title>
        {{ $tc('location') }} {{ $tc('history') }}:
        {{ moduleName === 'cmdb' ? asset.ciName : asset.name }}
      </template>
      <FlotoCrudContainer
        as-table
        prepend-new-item
        :columns="tableColumns"
        :fetch-fn="getLocationHistory"
      >
        <template v-slot:value="{ item }">
          <td class="resource-link">
            <FlotoLocationPicker
              :value="item.value"
              placeholder="---"
              size="small"
              disabled
              text-only
            />
          </td>
        </template>
        <template v-slot:startTime="{ item }">
          <td class="resource-link">
            <span v-if="item.startTime">{{ item.startTime | datetime }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:endTime="{ item }">
          <td class="resource-link">
            <span v-if="item.endTime">{{ item.endTime | datetime }}</span>
            <span v-else>---</span>
          </td>
        </template>
        <template v-slot:duration="{ item }">
          <td class="resource-link">
            {{ item.duration || '---' }}
          </td>
        </template>
      </FlotoCrudContainer>
      <template v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">
          {{ $t('done') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>
<script>
import { getUsedByOrLocationApi } from '@modules/asset/asset-api'
import { LicenseComputed } from '@state/modules/license'
export default {
  name: 'LocationHistoryDrawer',
  props: {
    asset: { type: Object, required: true },
    moduleName: { type: String, default: undefined },
  },
  data() {
    return {
      showDrawer: false,
      tableColumns: [
        {
          name: `${this.$tc('location')}`,
          key: 'value',
        },
        { name: `${this.$tc('start_date')}`, key: 'startTime' },
        {
          name: `${this.$tc('end_date')}`,
          key: 'endTime',
        },
        {
          name: `${this.$tc('duration')}`,
          key: 'duration',
        },
      ],
    }
  },
  computed: {
    ...LicenseComputed,
    hasAssetModule() {
      return this.availableModulesInLicense.indexOf(this.$constants.ASSET) >= 0
    },
    hasCmdbModule() {
      return this.availableModulesInLicense.indexOf(this.$constants.CMDB) >= 0
    },
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    hideDrawer() {
      this.showDrawer = false
    },
    getLocationHistory(limit, offset) {
      const filter = {
        type: 'location',
        ids: this.asset.id,
      }
      if (
        this.moduleName === this.$constants.CMDB ||
        this.moduleName === this.$constants.ASSET_HARDWARE
      ) {
        filter.moduleNames = [
          ...(this.hasCmdbModule ? [this.$constants.CMDB] : []),
          ...(this.hasAssetModule ? [this.$constants.ASSET_HARDWARE] : []),
        ]
      } else {
        filter.moduleName = this.moduleName
      }
      return getUsedByOrLocationApi(filter, limit, offset)
    },
  },
}
</script>
